import listingActionTypes from 'circe/listing/actionTypes';
import { NAME } from './constants';

export default {
  ...listingActionTypes(NAME),
  MARK_AS_PAID: `${NAME}/MARK_AS_PAID`,
  MARKED_AS_PAID: `${NAME}/MARKED_AS_PAID`,
};
